import dayjs from "dayjs";
import { useAtom } from "jotai";
import { useState } from "react";
import { usersAtom } from "./services/atoms";
import { useMutation, useQuery } from "./services/hooks";

const Comments = {
  comments: ['comments_with_articles?content=ilike.%$search%&limit=$limit&moderated=eq.1&order=created_at.desc', true]
}
const UpdateQuery = ['comments?id=eq.$id', 'PATCH']

export default () => {
  const [query, setQuery] = useState("");
  const [users] = useAtom(usersAtom);

  const [{ data, error }, reload] = useQuery({
    query: Comments,
    variables: {
      search: query,
      limit: query ? 10 : 50,
    },
  });

  const [_, unModerateComment] = useMutation(UpdateQuery);

  if (!data) return <div>Ładowanie...</div>;
  return (
    <div className="flex">
      <div className="w-full">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="border-2"
        />
        {data.comments.map((comment) => (
          <div className={comment.shown ? "bg-green-300" : "bg-red-300"}>
            Data: {dayjs.utc(comment.created_at).format("YYYY-MM-DD HH:mm")}
            <br />
            Nick: {comment.nick}
            <br />
            Shown: {comment.shown}
            <br />
            IP: {comment.ip}
            <br />
            <a target="_blank" href={`https://histmag.org/?id=${comment.post}`}>
              {comment.title}
            </a>
            <br />
            Content: <br />
            {comment.content}
            <br />
            <br />
            <button
              className="border-2 p-4"
              onClick={async () => {
                await unModerateComment({
                  id: comment.id,
                  data: {
                    shown: 0,
                    moderated: 0
                  }
                })
                reload()
              }}
            >
              unmoderate
            </button>
            <br />
            <br />
            Moderowane przez:
            {users.find((user) => user.id == comment.moderated_by)?.name}
            <br />
            <hr />
            <br />
          </div>
        ))}
      </div>
    </div>
  );
};
